import { fetchOk } from '../util/http';

let pdfUrl, lang, fileName;

document
  .getElementById("BtnGuideDownload")
  ?.addEventListener("click", async function (e) {
    e.preventDefault();

    lang = document.documentElement.lang;

    switch (lang) {
      case "es-ES":
        pdfUrl = "https://cdn.pilgrim.es/resources/Guia-de-iniciacion-al-camino-de-Santiago.pdf";
        fileName = "Guia-de-iniciacion-al-camino-de-Santiago.pdf";
        break;

      case "de-DE":
        pdfUrl = "https://cdn.pilgrim.es/resources/de/Der_Pilgerfuhrer_von_Pilgrim.pdf";
        fileName = "Der_Pilgerfuhrer_von_Pilgrim.pdf";
        break;

      case "en-US":
        pdfUrl = "https://cdn.pilgrim.es/resources/en/Introduction_to_the_camino_de_santiago.pdf";
        fileName = "Introduction_to_the_camino_de_santiago.pdf";
        break;

      case "it-IT":
        pdfUrl = "https://cdn.pilgrim.es/resources/it/Guida_introduttiva_al_Cammino_di_Santiago.pdf";
        fileName = "Guida_introduttiva_al_Cammino_di_Santiago.pdf";
        break;

      default:
        pdfUrl = "https://cdn.pilgrim.es/resources/Guia-de-iniciacion-al-camino-de-Santiago.pdf";
        fileName = "Guia-de-iniciacion-al-camino-de-Santiago.pdf";
        break;
    }

    try {
      // Intenta descargar desde la URL del CDN
      const response = await fetchOk(pdfUrl, { method: "GET" });
      const blob = await response.blob();

      // Descarga el archivo
      const link = document.createElement("a");
      const objectURL = URL.createObjectURL(blob);
      link.href = objectURL;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(objectURL);

      redirectAfterDownload(this.href);
    } catch (error) {
      console.warn(
        "Error al descargar, abriendo la URL del CDN en nueva pestaña:",
        error
      );

      // Si falla la descarga, abre la URL del CDN directamente
      window.open(pdfUrl, "_blank");

      redirectAfterDownload(this.href);
    }
  });

function redirectAfterDownload(href) {
  setTimeout(() => {
    window.location.href = href;
  }, 1500);
}
